/* eslint-disable */
import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { shipmentListUrlSortField } from "@saleor/shipment/urls";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";
import { popupSection, PopupUrlQueryParams } from "./urls";
import PopupComponent from "./views/PopupDetails";

const popupList: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: PopupUrlQueryParams = asSortParams(
    qs,
    shipmentListUrlSortField
  );
  return <PopupComponent params={params} />;
};

export const PopupSection: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.loginpopup)} />
      <Switch>
        <Route exact path={popupSection} component={popupList} />
      </Switch>
    </>
  );
};

export default PopupSection;
